import React, {useEffect, useState} from "react";
import Header from "../../components/header/header";
import DeviceModal from "../../components/device_modal/device_modal";
import TableComponent from "../../components/table/table";
import axiosInstance from "../../AxiosInstance";
import PageTitle from "../../components/page_title/page_title";
import {LogoInput, SliderInput, TextInput} from "../../components/input/inputs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboard, faEdit, faFileText, faMapPin, faSearch} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import styles from './devices.module.css';
import {useNavigate} from "react-router-dom";
import EmptyPlaceholder from "../../components/empty_placeholder/empty_placeholder";
import Modal from "../../components/modal/modal";
import ReactJson from "react-json-view";
import {toast, ToastTypes} from "../../components/ajonjolib/toasts/toast/toast";
import ToastContainer from "../../components/ajonjolib/toasts/toast/toast_container";
import {Label, Select} from "../../components/ajonjolib/inputs/ajonjolinput";
import VerticalInput from "../../components/vertical_input/vertical_input";
import GoogleMapReact from "google-map-react";
import PaginationControls, {getStoredPageSize} from "../../components/pagination/PaginationControls";

export default function DeviceList() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [form, setForm] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showJson, setShowJson] = useState(false);
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(getStoredPageSize);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editForm, setEditForm] = useState({});
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [machineOptions, setMachineOptions] = useState([]);
    const [showVariableSettings, setShowVariableSettings] = useState(false);
    const [deviceVariables, setDeviceVariables] = useState([]);
    const [selectedVariable, setSelectedVariable] = useState(null);
    const [tagsInput, setTagsInput] = useState('');
    const [variableSettingsForm, setVariableSettingsForm] = useState({
        precision: 0,
        low_threshold: 0,
        medium_threshold: 0,
        low_threshold_2: 0,
        medium_threshold_2: 0,
        high_active: true,
        medium_active: true,
        low_active: true
    });
    const [showMapInEdit, setShowMapInEdit] = useState(false);
    const [mapCenter, setMapCenter] = useState({lat: 14.7273, lng: -17.4580});
    const [addressInput, setAddressInput] = useState('');
    const project_id = parseInt(localStorage.getItem('project_id'));

    const fetchDevices = () => {
        const pid = localStorage.getItem('project_id');
        console.log('fetchDevices called, project_id:', pid);
        if (!pid) return;
        axiosInstance.get(`device/?project_id=${pid}`).then((response) => {
            console.log('Devices fetched:', response.data.length);
            setRows(response.data);
        }).catch((err) => {
            console.error('Error fetching devices:', err);
        });
    };

    useEffect(() => {
        let isMounted = true;

        const pid = localStorage.getItem('project_id');
        if (pid) {
            axiosInstance.get(`device/?project_id=${pid}`).then((response) => {
                if (isMounted) setRows(response.data);
            }).catch((err) => {
                if (isMounted) console.error('Error fetching devices:', err);
            });
        }

        axiosInstance.get('device_type/').then((response) => {
            if (isMounted) setDeviceTypes(response.data.results);
        }).catch(() => {});

        axiosInstance.get('machine/').then((response) => {
            if (isMounted) setMachineOptions(response.data);
        }).catch(() => {});

        const intervalId = setInterval(() => {
            const p = localStorage.getItem('project_id');
            if (!p) return;
            axiosInstance.get(`device/?project_id=${p}`).then((response) => {
                if (isMounted) setRows(response.data);
            }).catch(() => {});
        }, 10000);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [])

    const formatTimestamp = (timestamp) => {
        if(timestamp == null) return "-";
        const date = new Date(timestamp);
        return date.toLocaleString('en-GB');
    }

    const getBatteryStyle = (val) => {
        // Si no hay valor de batería o es 100 (valor por defecto sin batería), mostrar "-"
        if(val == null || val === 100 || val === "100") {
            return <div>-</div>;
        }

        if(val <= 20) {
            return (<div className={styles.batteryContainer}>
                <div className={styles.batteryLevel} style={{width: `${parseInt(val)}%`, backgroundColor: "red"}}></div>
                <div className={styles.batteryNumber}>{parseInt(val) + "%"}</div>
            </div>);
        } else if(val <= 50) {
            return (<div className={styles.batteryContainer}>
                <div className={styles.batteryLevel} style={{width: `${parseInt(val)}%`, backgroundColor: "orange"}}></div>
                <div className={styles.batteryNumber}>{parseInt(val) + "%"}</div>
            </div>);
        } else {
            return (<div className={styles.batteryContainer}>
                <div className={styles.batteryLevel} style={{width: `${parseInt(val)}%`}}></div>
                <div className={styles.batteryNumber}>{parseInt(val) + "%"}</div>
            </div>);
        }
    }

    const cols = [
        {title: t('devices.deviceName'), internal: "name"},
        {title: t('devices.type'), internal: "type.name"},
        {title: t('devices.battery'), internal: "battery", code: (row, data) => {
            // Verificar si el device type tiene batería configurada
            if (row.type?.has_battery === false) {
                return <div>-</div>;
            }
            return getBatteryStyle(data);
            }},
        {title: t('devices.serialNumber'), internal: "sn"},
        {title: t('devices.tags'), internal: "tags", code: (row, data) => {
            if (!data) return <div>-</div>;
            const tags = data.split(' ').filter(tag => tag && tag !== 'undefined');
            if (tags.length === 0) return <div>-</div>;
            return (
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                    {tags.map((tag, index) => (
                        <span key={index} style={{
                            backgroundColor: '#e7f1ff',
                            color: '#0d6efd',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: '500'
                        }}>
                            {tag}
                        </span>
                    ))}
                </div>
            );
        }},
        {title: t('devices.lastMessage'), internal: "last_message", code: (row, data) => {
            return (
                <div>
                    <div>{formatTimestamp(data)}</div>
                    <div role={'button'} style={{color: '#007bff', fontWeight: '600'}} onClick={() => {
                        setSelectedRow(row);
                        setShowJson(true);
                    }}>Show</div>
                </div>
            );
            }
        },
        {
            title: "", internal: "id", code: (row) => {
                return (
                    <div className={'d-flex gap-2'}>
                        <div className={styles.editButton} onClick={() => openEditModal(row)}>
                            <FontAwesomeIcon icon={faEdit} />
                        </div>
                        <div className={styles.showButton} onClick={() => {
                            localStorage.setItem('device', JSON.stringify(row));
                            navigate('/variables')
                        }}>Show</div>
                    </div>
                );
            }
        },
    ]

    const search = () => {
        console.log(form);
        const searchTerm = form['name'] || '';
        const url = `device/?project_id=${project_id}&name=${searchTerm}&tags=${searchTerm}`;
        axiosInstance.get(url).then((response) => {
            setRows(response.data);
            setPage(1);
            toast("Devices filtered", ToastTypes.INFO);
        });
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            search();
        }
    }

    const openEditModal = (device) => {
        setEditForm({
            ...device,
            type: device.type?.id || device.type,
            device_user_id: device.device_user || device.device_user_id
        });
        setTagsInput('');
        setShowMapInEdit(false);
        setAddressInput('');

        // Set map center to device location if available
        if (device.latitude && device.longitude) {
            setMapCenter({lat: parseFloat(device.latitude), lng: parseFloat(device.longitude)});
        } else {
            setMapCenter({lat: 14.7273, lng: -17.4580});
        }

        // Cargar las variables del device
        axiosInstance.get(`variable_data/?device_id=${device.id}`).then((response) => {
            setDeviceVariables(response.data);
        });

        setShowEditModal(true);
    }

    const handleMapClick = ({lat, lng}) => {
        setEditForm({
            ...editForm,
            latitude: lat,
            longitude: lng
        });
    };

    const handleMovePin = async () => {
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addressInput)}&key=AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g`
            );
            const data = await response.json();

            if (data.results.length > 0) {
                const {lat, lng} = data.results[0].geometry.location;
                setMapCenter({lat: lat, lng: lng});
                setEditForm({
                    ...editForm,
                    latitude: lat,
                    longitude: lng
                });
            } else {
                toast("Address not found", ToastTypes.ERROR);
            }
        } catch (error) {
            console.error('Error fetching geocoding data', error);
            toast("Error searching address", ToastTypes.ERROR);
        }
    };

    const syncDeviceVariables = async () => {
        try {
            const response = await axiosInstance.post('variable_data/sync/', {
                device_id: editForm.id
            });

            const { created, deleted, existing, created_buttons, details } = response.data;

            // Mostrar mensaje al usuario
            if (created > 0 || deleted > 0 || created_buttons > 0) {
                const parts = [];
                if (created > 0) parts.push(`${created} variable(s) creada(s)`);
                if (deleted > 0) parts.push(`${deleted} variable(s) eliminada(s)`);
                if (created_buttons > 0) parts.push(`${created_buttons} botón/es añadido(s): ${details?.created_buttons?.join(', ')}`);
                toast(parts.join(' · '), ToastTypes.SUCCESS);

                // Recargar las variables del device
                const variablesResponse = await axiosInstance.get(`variable_data/?device_id=${editForm.id}`);
                setDeviceVariables(variablesResponse.data);
            } else {
                toast(t('adminDeviceTypes.alreadySynced'), ToastTypes.INFO);
            }
        } catch (err) {
            console.error('Error syncing variables:', err);
            console.error('Error response:', err.response?.data);

            let errorMessage = t('adminDeviceTypes.errorSyncingVariables');
            if (err.response?.data) {
                const errorData = err.response.data;
                if (typeof errorData === 'object' && errorData.error) {
                    errorMessage += ': ' + errorData.error;
                } else if (typeof errorData === 'string') {
                    errorMessage += ': ' + errorData;
                }
            }

            toast(errorMessage, ToastTypes.ERROR);
        }
    }

    const openVariableSettings = (variable) => {
        setSelectedVariable(variable);
        setVariableSettingsForm({
            precision: variable.precision || 0,
            low_threshold: variable.low_threshold || 0,
            medium_threshold: variable.medium_threshold || 0,
            low_threshold_2: variable.low_threshold_2 || 0,
            medium_threshold_2: variable.medium_threshold_2 || 0,
            high_active: variable.high_active === undefined || variable.high_active === null ? true : variable.high_active,
            medium_active: variable.medium_active === undefined || variable.medium_active === null ? true : variable.medium_active,
            low_active: variable.low_active === undefined || variable.low_active === null ? true : variable.low_active,
            green_1: variable.low_threshold || 0,
            yellow_1: variable.medium_threshold || 0,
            green_2: variable.low_threshold_2 || 0,
            yellow_2: variable.medium_threshold_2 || 0,
        });
        setShowVariableSettings(true);
    }

    const saveVariableSettings = () => {
        const payload = {
            precision: variableSettingsForm.precision,
            low_threshold: variableSettingsForm.green_1,
            medium_threshold: variableSettingsForm.yellow_1,
            low_threshold_2: variableSettingsForm.green_2,
            medium_threshold_2: variableSettingsForm.yellow_2,
            high_active: variableSettingsForm.high_active,
            medium_active: variableSettingsForm.medium_active,
            low_active: variableSettingsForm.low_active,
        };

        console.log('Saving variable settings for ID:', selectedVariable.id);
        console.log('Payload:', payload);
        console.log('Current form state:', variableSettingsForm);

        axiosInstance.put(`variable_data/${selectedVariable.id}/`, payload).then((response) => {
            console.log('Save successful, response:', response.data);
            console.log('Response active flags:', {
                high_active: response.data.high_active,
                medium_active: response.data.medium_active,
                low_active: response.data.low_active
            });
            toast("Variable settings updated successfully", ToastTypes.SUCCESS);
            setShowVariableSettings(false);
            // Recargar las variables del device
            axiosInstance.get(`variable_data/?device_id=${editForm.id}`).then((response) => {
                console.log('Reloaded variables:', response.data);
                console.log('First variable active flags:', {
                    high_active: response.data[0]?.high_active,
                    medium_active: response.data[0]?.medium_active,
                    low_active: response.data[0]?.low_active
                });
                setDeviceVariables(response.data);
            });
        }).catch((err) => {
            console.error('Error updating variable settings:', err);
            console.error('Error response:', err.response?.data);

            let errorMessage = 'Error updating variable settings';
            if (err.response?.data) {
                const errorData = err.response.data;
                if (typeof errorData === 'object') {
                    errorMessage += ': ' + JSON.stringify(errorData);
                } else {
                    errorMessage += ': ' + errorData;
                }
            }

            toast(errorMessage, ToastTypes.ERROR);
        });
    }

    const saveDevice = () => {
        let formData = new FormData();

        // Agregar todos los campos al FormData
        for(const key in editForm) {
            if (key === 'image_file' && editForm[key]) {
                formData.append(key, editForm[key]);
            } else if (key !== 'image' && key !== 'variables') {
                formData.append(key, editForm[key]);
            }
        }

        // Asegurar que tags se envíe correctamente
        console.log('Saving device with tags:', editForm.tags);
        console.log('FormData contents:');
        for (let [key, value] of formData.entries()) {
            console.log('  ', key, ':', value);
        }

        axiosInstance.put(`device/${editForm.id}/`, formData).then((response) => {
            console.log('Server response:', response.data);
            setShowEditModal(false);
            toast("Device updated successfully", ToastTypes.SUCCESS);
            // Recargar la lista de devices
            axiosInstance.get(`device/?project_id=${project_id}`).then((response) => {
                setRows(response.data);
            });
        }).catch((err) => {
            console.error('Error updating device:', err);
            toast("Error updating device", ToastTypes.ERROR);
        });
    }

    useEffect(() => {
        // Add a global event listener for keydown
        window.addEventListener('keydown', handleKeyPress);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [form]);

    return (
        <div className={styles.dashboard_container}>
            <Header sidebarIndex={2}/>

            <DeviceModal show={showModal} setter={setShowModal} withMachine={true}/>

            <Modal hideCancel={true} show={showJson} setter={setShowJson} name={`Last message (${formatTimestamp(selectedRow?.last_message)})`} onClick={() => setShowJson(false)} buttonName={'Close'}>
                <div>
                    <div style={{borderRadius: '8px', border: '#CCC 1px solid', overflowY: 'scroll', height: '500px'}} className={'p-2'}>
                        <ReactJson src={selectedRow?.last_message_content} theme={'light'} collapsed={false} displayDataTypes={false} displayObjectSize={false} enableClipboard={false}/>
                    </div>
                </div>
            </Modal>

            <Modal show={showEditModal} setter={setShowEditModal} name={t('common.edit')} onClick={saveDevice} buttonName={t('common.save')}>
                <div>
                    <LogoInput name={'Device Logo'} current={editForm?.image?.image} internalName={'image_file'} form={editForm} setForm={setEditForm} hideName={true}/>
                    <TextInput name={'Device Name'} internalName={'name'} form={editForm} setForm={setEditForm}/>
                    <TextInput name={'Device EUI (SN)'} internalName={'sn'} form={editForm} setForm={setEditForm}/>
                    <TextInput name={'App Key'} internalName={'app_key'} form={editForm} setForm={setEditForm}/>
                    <TextInput name={'App EUI'} internalName={'app_eui'} form={editForm} setForm={setEditForm}/>
                    <div className={'mb-3'}>
                        <Label>Device Type</Label>
                        <Select
                            onChange={(value) => setEditForm({...editForm, type: value?.[0]})}
                            value={editForm.type != null ? [editForm.type] : null}
                            options={deviceTypes.map((x) => {return {name: x.name, value: x.id}})}
                        />
                    </div>
                    <div className={'mb-3'}>
                        <Label>Machine</Label>
                        <Select
                            onChange={(value) => setEditForm({...editForm, device_user_id: value?.[0]})}
                            value={editForm.device_user_id != null ? [editForm.device_user_id] : null}
                            options={machineOptions.map((x) => {return {name: x.name, value: x.id}})}
                        />
                    </div>
                    <div className={'d-flex flex-wrap mb-2'}>
                        {editForm.tags?.split(' ').filter(tag => tag && tag !== 'undefined').map((tag, index) => (
                            <div key={index} style={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#e9ecef',
                                borderRadius: '16px',
                                padding: '4px 12px',
                                margin: '2px 4px 2px 0',
                                fontSize: '14px'
                            }} role={'button'} onClick={() => {
                                const currentTags = editForm.tags || '';
                                const newTags = currentTags.split(' ').filter(t => t !== tag).join(' ');
                                setEditForm({
                                    ...editForm,
                                    tags: newTags,
                                });
                            }}>
                                <div>{tag}</div>
                                <div className={'ms-2 d-flex flex-column align-items-center align-content-center justify-content-center'} style={{
                                    backgroundColor: '#a2a2a2',
                                    borderRadius: '50%',
                                    padding: '0 7px',
                                    color: '#fff',
                                    fontSize: '12px'
                                }}>x</div>
                            </div>
                        ))}
                    </div>
                    <div className="form-group mb-3">
                        <div className={`mb-1`} style={{color: "#4B5563"}}>Tags</div>
                        <input
                            type={'text'}
                            className={`form-control rounded-2`}
                            style={{border: '1px solid #D1D5DB'}}
                            placeholder={'Enter tags and press Enter or Space'}
                            value={tagsInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    const value = tagsInput.trim();
                                    if (value) {
                                        const currentTags = editForm.tags || '';
                                        const newTags = currentTags ? currentTags + ' ' + value : value;
                                        console.log('Adding tag (Enter):', value, 'New tags:', newTags);
                                        setEditForm({
                                            ...editForm,
                                            tags: newTags,
                                        });
                                        setTagsInput('');
                                    }
                                }
                            }}
                            onChange={(event) => {
                                const { value } = event.target;
                                if (value.endsWith(' ')) {
                                    const trimmedValue = value.trim();
                                    if (trimmedValue) {
                                        const currentTags = editForm.tags || '';
                                        const newTags = currentTags ? currentTags + ' ' + trimmedValue : trimmedValue;
                                        console.log('Adding tag (Space):', trimmedValue, 'New tags:', newTags);
                                        setEditForm({
                                            ...editForm,
                                            tags: newTags,
                                        });
                                    }
                                    setTagsInput('');
                                } else {
                                    setTagsInput(value);
                                }
                            }}
                        />
                    </div>
                    {!showMapInEdit ? (
                        <div className={'mb-3'} onClick={() => {
                            // Center map on saved coordinates when opening
                            if (editForm.latitude && editForm.longitude) {
                                setMapCenter({lat: parseFloat(editForm.latitude), lng: parseFloat(editForm.longitude)});
                            }
                            setShowMapInEdit(true);
                        }}>
                            <div className={`mb-1`} style={{color: "#4B5563"}}>Device Location</div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '10px 15px',
                                border: '1px solid #D1D5DB',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                backgroundColor: '#f8f9fa'
                            }}>
                                <FontAwesomeIcon icon={faMapPin} color={'#F00'}/>
                                <div>{editForm.latitude && editForm.longitude
                                    ? `${parseFloat(editForm.latitude).toFixed(6)}, ${parseFloat(editForm.longitude).toFixed(6)}`
                                    : 'Click to set location'}</div>
                            </div>
                        </div>
                    ) : (
                        <div className={'mb-3'}>
                            <div className={`mb-1`} style={{color: "#4B5563"}}>Device Location</div>
                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '8px'}}>
                                <input
                                    type="text"
                                    placeholder="Enter address to search"
                                    value={addressInput}
                                    onChange={(event) => setAddressInput(event.target.value)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            handleMovePin();
                                        }
                                    }}
                                    style={{padding: '8px', flex: 1, border: '1px solid #D1D5DB', borderRadius: '6px 0 0 6px'}}
                                />
                                <button
                                    type="button"
                                    onClick={handleMovePin}
                                    style={{padding: '8px 15px', backgroundColor: '#007bff', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '0 6px 6px 0'}}
                                >
                                    Search
                                </button>
                            </div>
                            <div style={{height: "250px", borderRadius: '6px', overflow: 'hidden', border: '1px solid #D1D5DB'}}>
                                <GoogleMapReact
                                    onClick={handleMapClick}
                                    defaultCenter={{lat: 14.7273, lng: -17.4580}}
                                    defaultZoom={16}
                                    bootstrapURLKeys={{key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g'}}
                                    center={mapCenter}
                                    onChange={(event) => setMapCenter(event.center)}
                                    yesIWantToUseGoogleMapApiInternals
                                >
                                    {editForm.latitude && editForm.longitude && (
                                        <div
                                            lat={parseFloat(editForm.latitude)}
                                            lng={parseFloat(editForm.longitude)}
                                            style={{width: '20px', height: '20px'}}
                                            className={'d-flex justify-content-center align-items-center'}
                                        >
                                            <FontAwesomeIcon icon={faMapPin} color={'#F00'} size={'xl'}/>
                                        </div>
                                    )}
                                </GoogleMapReact>
                            </div>
                            <div className="mt-2 d-flex justify-content-between align-items-center">
                                <small style={{color: '#6c757d'}}>
                                    {editForm.latitude && editForm.longitude
                                        ? `Lat: ${parseFloat(editForm.latitude).toFixed(6)}, Lng: ${parseFloat(editForm.longitude).toFixed(6)}`
                                        : 'Click on the map to set location'}
                                </small>
                                <button
                                    type="button"
                                    onClick={() => setShowMapInEdit(false)}
                                    style={{padding: '4px 12px', backgroundColor: '#6c757d', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '4px', fontSize: '12px'}}
                                >
                                    Done
                                </button>
                            </div>
                        </div>
                    )}

                    <hr className="my-4" />
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">{t('variables.settings')}</h6>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                syncDeviceVariables();
                            }}
                            title={t('adminDeviceTypes.syncVariablesTitle')}
                        >
                            ↻ {t('adminDeviceTypes.syncVariables')}
                        </button>
                    </div>
                    {deviceVariables.length > 0 ? (
                        <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                            {deviceVariables.map((variable, index) => (
                                <div
                                    key={index}
                                    className="d-flex justify-content-between align-items-center p-2 mb-2"
                                    style={{
                                        border: '1px solid #dee2e6',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        backgroundColor: '#f8f9fa'
                                    }}
                                    onClick={() => openVariableSettings(variable)}
                                >
                                    <div>
                                        <div style={{fontWeight: '600'}}>{variable.name || variable.variable?.name}</div>
                                        <small style={{color: '#6c757d'}}>
                                            {t('adminDeviceTypes.precision')}: {variable.precision || 0}
                                        </small>
                                    </div>
                                    <FontAwesomeIcon icon={faEdit} style={{color: '#007bff'}} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4" style={{color: '#6c757d'}}>
                            <p>{t('adminDeviceTypes.noVariablesConfigured')}</p>
                            <p>{t('adminDeviceTypes.clickSyncToAdd')}</p>
                        </div>
                    )}
                </div>
            </Modal>

            <Modal show={showVariableSettings} setter={setShowVariableSettings} name={`${t('adminDeviceTypes.configure')}: ${selectedVariable?.name || selectedVariable?.variable?.name}`} onClick={saveVariableSettings} buttonName={t('common.save')}>
                <div>
                    <div className="mb-4">
                        <div><b>{t('variables.decimalPrecision')}</b></div>
                        <div style={{fontSize: "x-large"}}><b>{variableSettingsForm.precision}</b></div>
                        <SliderInput
                            min={0}
                            max={5}
                            step={1}
                            name={'precision'}
                            form={variableSettingsForm}
                            setForm={setVariableSettingsForm}
                        />
                    </div>
                    <div className="mb-4" style={{height: "1px", backgroundColor: "#CBD5E1"}}/>
                    <div className="mb-4">
                        <div className="mb-3"><b>{t('adminDeviceTypes.alertThresholds')}</b></div>
                        <VerticalInput form={variableSettingsForm} setForm={setVariableSettingsForm}/>
                    </div>
                    <div className="mb-4" style={{height: "1px", backgroundColor: "#CBD5E1"}}/>
                </div>
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <PageTitle title={t('devices.title')} createName={t('devices.device')} openModal={setShowModal}/>

                <div className={'d-flex mt-2 justify-content-between align-items-center'}>
                    <div className={'d-flex'} style={{flexBasis: '50%'}}>
                        <div style={{flexBasis: '25%', minWidth: "200px"}}>
                            <TextInput name={'name'} hideName={true} internalName={'name'} form={form} setForm={setForm} placeholder={t('common.searchPlaceholder')} noMargin={true}/>
                        </div>
                        <div style={{backgroundColor: '#007bff', color: '#fff', borderRadius: '6px', cursor: 'pointer'}} className={'px-3 align-content-center d-flex flex-column justify-content-center ms-2'} onClick={() => search()}>
                            <FontAwesomeIcon icon={faSearch}/>
                        </div>
                    </div>
                </div>

                {rows.length > 0 ? (() => {
                    const totalPages = Math.ceil(rows.length / pageSize);
                    const pagedRows = rows.slice((page - 1) * pageSize, page * pageSize);
                    const handlePageSizeChange = (newSize) => { setPageSize(newSize); setPage(1); };
                    return (<>
                    {/* Desktop table */}
                    <div className={`mt-3 ${styles.desktopTable}`}>
                        <TableComponent fetchUrl={'device'} cols={cols} rows={pagedRows} pull={setRows} noPagination={true} defaultFilters={{
                            'project_id': project_id
                        }}/>
                    </div>

                    {/* Mobile cards */}
                    <div className={styles.mobileCards}>
                        {pagedRows.map((device) => (
                            <div key={device.id} className={styles.deviceCard}>
                                <div className={styles.cardRow}>
                                    <div className={styles.cardName}>{device.name}</div>
                                    <div className={styles.cardActions}>
                                        <div className={styles.editButton} onClick={() => openEditModal(device)}>
                                            <FontAwesomeIcon icon={faEdit}/>
                                        </div>
                                        <div className={styles.showButton} onClick={() => {
                                            localStorage.setItem('device', JSON.stringify(device));
                                            navigate('/variables');
                                        }}>Show</div>
                                    </div>
                                </div>
                                <div className={styles.cardMeta}>
                                    {device.type?.name && <span><b>{t('devices.type')}:</b> {device.type.name}</span>}
                                    {device.sn && <span><b>SN:</b> {device.sn}</span>}
                                    {device.type?.has_battery !== false && device.battery != null && device.battery !== 100 && device.battery !== "100" &&
                                        <span><b>{t('devices.battery')}:</b> {parseInt(device.battery)}%</span>
                                    }
                                    {device.last_message && <span><b>{t('devices.lastMessage')}:</b> {formatTimestamp(device.last_message)}</span>}
                                </div>
                                {device.tags && device.tags.split(' ').filter(tag => tag && tag !== 'undefined').length > 0 && (
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                                        {device.tags.split(' ').filter(tag => tag && tag !== 'undefined').map((tag, i) => (
                                            <span key={i} className={styles.cardTag}>{tag}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <PaginationControls
                        page={page}
                        totalPages={totalPages}
                        pageSize={pageSize}
                        onPageChange={setPage}
                        onPageSizeChange={handlePageSizeChange}
                        totalCount={rows.length}
                    />
                </>);
                })() :
                    <EmptyPlaceholder type={'devices'}/>
                }
            </div>
            <ToastContainer/>
        </div>
    );
}